<template>
  <div>
    <h1>Tutorial</h1>
    <div>
      Preparing....
    </div>
  </div>
</template>

<script>
export default {
  name: 'tutorial-page'

}
</script>

<style lang="css" scoped>
.counter-number {
  font-size: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/TutorialPage.vue